import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { GET_STORES_FOR_CATEGORY_PRODUCTS } from 'mocks/queries';
import useUserLocation from 'global-state/userLocation/useUserLocation';

// Limit to top 5 closest stores not to clutter up the modal
const MAX_STORES_PER_PRODUCT = 5;

const useProductStoresForCategory = ({ categorySlug, skip = false }) => {
  const userLocation = useUserLocation();
  const zipCode = userLocation?.zip ?? '';

  const { data, loading, error } = useQuery(GET_STORES_FOR_CATEGORY_PRODUCTS, {
    variables: {
      categorySlug,
      zipCode,
      limit: MAX_STORES_PER_PRODUCT,
    },
    skip: skip || !zipCode || !categorySlug,
  });

  const storesData = useMemo(() => {
    if (!data?.getStoresForCategoryProducts) {
      return {
        storesLookup: {},
        productStoresMap: {},
        productDistancesMap: {},
      };
    }

    const { stores, productStores } = data.getStoresForCategoryProducts;

    const storesLookup = stores.reduce((acc, store) => {
      acc[store.id] = store;
      return acc;
    }, {});

    const { productStoresMap, productDistancesMap } = productStores.reduce(
      (acc, { productId, storeIds, distances }) => {
        acc.productStoresMap[productId] = storeIds;
        acc.productDistancesMap[productId] = distances;
        return acc;
      },
      { productStoresMap: {}, productDistancesMap: {} }
    );

    return {
      storesLookup,
      productStoresMap,
      productDistancesMap,
    };
  }, [data]);

  return {
    ...storesData,
    loading,
    error,
  };
};

export default useProductStoresForCategory;
